/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import common from '../locales/en/common.json';
import location from '../locales/en/location.json';
import propertiesFeature from '../locales/en/features/properties.json';
import visits from '../locales/en/features/visits.json';
import members from '../locales/en/features/members.json';
import blog from '../locales/en/features/blog.json';
import popups from '../locales/en/features/popups.json';
import filters from '../locales/en/features/filters.json';
import pricing from '../locales/en/features/pricing.json';
import clients from '../locales/en/features/clients.json';
import cookieConsent from '../locales/en/features/cookie-consent.json';
import agencySettings from '../locales/en/features/agency-settings.json';
import agenda from '../locales/en/features/agenda.json';
import landing from '../locales/en/pages/landing.json';
import earlyAccess from '../locales/en/pages/early-access.json';
import notFound from '../locales/en/pages/not-found.json';
import error from '../locales/en/pages/error.json';
import agencies from '../locales/en/pages/agencies.json';
import propertiesPage from '../locales/en/pages/properties.json';
import manageAgencies from '../locales/en/pages/manage-agencies.json';
import manageProperties from '../locales/en/pages/manage-properties.json';
import registerAgency from '../locales/en/pages/register-agency.json';
import propertyPages from '../locales/en/pages/property-pages.json';
import layout from '../locales/en/pages/layout.json';
import policy from '../locales/en/pages/policy.json';
import onboarding from '../locales/en/pages/onboarding.json';
import welcome from '../locales/en/pages/welcome.json';
import userSettings from '../locales/en/pages/user-settings.json';
import publicProperty from '../locales/en/pages/public-property.json';
import dataRights from '../locales/en/pages/data-rights.json';
import visitsPage from '../locales/en/pages/visits.json';
import agencySiteConfig from '../locales/en/features/agency-site-config.json';
import deals from '../locales/en/features/deals.json';
import attendances from '../locales/en/features/attendances.json';
import leases from '../locales/en/features/leases.json';
import sales from '../locales/en/features/sales.json';
import vistories from '../locales/en/features/vistories.json';
import partnerships from '../locales/en/features/partnerships.json';
import launches from '../locales/en/features/launches.json';
import productTour from '../locales/en/features/product-tour.json';
import subscription from '../locales/en/features/subscription.json';
import spreadsheets from '../locales/en/features/spreadsheets.json';
import supportAccess from '../locales/en/features/support-access.json';
import assistant from '../locales/en/features/assistant.json';

/**
 * English translation namespaces.
 */
export const en = {
  common,
  location,
  'features/properties': propertiesFeature,
  '@features/properties': propertiesFeature,
  'features/visits': visits,
  'features/members': members,
  'features/blog': blog,
  'features/popups': popups,
  'features/filters': filters,
  'features/pricing': pricing,
  'features/clients': clients,
  '@features/clients': clients,
  'features/cookie-consent': cookieConsent,
  'features/agency-settings': agencySettings,
  '@pages/landing': landing,
  'features/agenda': agenda,
  '@pages/early-access': earlyAccess,
  '@pages/not-found': notFound,
  '@pages/error': error,
  '@pages/agencies': agencies,
  '@pages/properties': propertiesPage,
  '@pages/manage-agencies': manageAgencies,
  '@pages/manage-properties': manageProperties,
  '@pages/register-agency': registerAgency,
  '@pages/property-pages': propertyPages,
  '@pages/layout': layout,
  '@pages/policy': policy,
  '@pages/onboarding': onboarding,
  '@pages/welcome': welcome,
  '@pages/user-settings': userSettings,
  '@pages/public-property': publicProperty,
  '@pages/data-rights': dataRights,
  '@pages/visits': visitsPage,
  'features/agency-site-config': agencySiteConfig,
  'features/deals': deals,
  'features/attendances': attendances,
  'features/leases': leases,
  'features/sales': sales,
  'features/vistories': vistories,
  'features/partnerships': partnerships,
  'features/launches': launches,
  'features/product-tour': productTour,
  'features/subscription': subscription,
  'features/spreadsheets': spreadsheets,
  'features/support-access': supportAccess,
  'features/assistant': assistant,
};
